export default __webpack_public_path__ + "static/assets/med_capsule_V_solid_01_m.8b96dfef.png";